import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconVideoFillComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-VideoFill${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path d="M5.33203 6C3.12289 6 1.33203 7.79086 1.33203 10V22C1.33203 24.2091 3.12289 26 5.33203 26H19.9987C22.2078 26 23.9987 24.2091 23.9987 22V17.7333L30.3438 23.2324C30.9913 23.7936 31.9987 23.3336 31.9987 22.4767V9.5233C31.9987 8.66637 30.9913 8.20638 30.3438 8.76761L23.9987 14.2667V10C23.9987 7.79086 22.2078 6 19.9987 6H5.33203Z" fill={useCurrentColor ? 'currentColor' : '#009E3D'}/></svg>;
}

const IconVideoFill = React.forwardRef(IconVideoFillComponent);
export default IconVideoFill;
